import { render, staticRenderFns } from "./CampoCliente.vue?vue&type=template&id=3b92afea"
import script from "./CampoCliente.vue?vue&type=script&lang=js"
export * from "./CampoCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports